import {modifiyDocumentById, queryDocuments, uploadDocuments} from '@/network/util/defectDBUtils'
import {code_pack} from '@/interfaces/code_pack'
import {code_info} from '@/interfaces/code_info'
import {BaseRequest} from '@/network/requests/BaseRequest'
import {codeInfoRequest} from '@/network/requests/codeInfo'

export const codePackRequest = BaseRequest.build<code_pack>('code_pack');

/**
 * 上传码包
 * @param name 码包名称
 * @param codeList 码值列表
 * @param productId 码包对应的产品id
 * @param productName 产品名称
 */
export async function uploadCodePack(name: string, codeList: string[], productId: string, productName: string) {
	if (!codeList || codeList.length === 0) {
		throw new Error("必须提供要上传的码包所包含的码信息！");
	}
	if (!(codeList instanceof Array)) {
		throw new Error("码包必须是字符串数组！");
	}
	const codePack = {
		jt_ids: [],
		name,
		product_id: productId,
		status: 0,
		product_name: productName,
		$currentDate: { created_time: true }
	}
	const codePackId = await codePackRequest.upload(codePack);
	return codeInfoRequest.uploadBatch(codeList.map(value => {
		const codeInfo: code_info = {
			code_pack_id: codePackId,
			is_used: 0,
			jt_ids: [],
			value
		}
		return codeInfo;
	}));
}

/**
 * 查询码包列表
 * @param pagesize 分页大小
 * @param page 页码
 * @param nameSearch 码包名称搜索
 * @param filterStatus 码包状态筛选，数组类型，包含要查看的状态
 * @param createdTimeSort 时间排序方式， -1 后上传的在前显示， 1 先上传的在前显示
 */
export async function queryCodePackList(pagesize: number, page: number, nameSearch= '', filterStatus: (0 | 1 | 2)[] = [0, 1, 2], createdTimeSort: -1 | 1 = -1) {
	const filter: any = {
		status: {$in: filterStatus}
	};
	if (nameSearch) {
		filter.name = {$regex: nameSearch};
	}
	return codePackRequest.queryPage({
		page,
		pagesize,
		filter,
		sort: {created_time: createdTimeSort}
	});
}

/**
 * 设置使用码包的机台
 * @param codePackId 码包id
 * @param jtIds 机台id数组
 */
export async function setJTListOfCodePack(codePackId: string, jtIds: string[]) {
	return codePackRequest.modifyById(codePackId,{
		jt_ids: jtIds
	});
}

/**
 * 查询指定码包的码值信息
 * @param pagesize 分页大小
 * @param page 页码
 * @param codePackId 码包id
 * @param filterIsUsed 筛选的码值使用状态列表，0未使用，1已使用，2有重码
 */
export async function queryCodeInfoOfCodePack(pagesize: number, page: number, codePackId: string, filterIsUsed: (0 | 1 | 2)[] = [0, 1, 2]) {
	const filter: any = {
		code_pack_id: codePackId,
		is_used: {$in: filterIsUsed}
	};
	return codeInfoRequest.queryPage({
		page,
		pagesize,
		filter,
	})
}

/**
 * 修改指定码包的信息
 * @param codePackId 码包id
 * @param name 码包名称
 */
export async function updateCodeInfo(codePackId: string, info: object) {
	return codePackRequest.modifyById(codePackId,info);
}

export async function deleteCodePack(codePackId: string) {
	return codePackRequest.deleteById(codePackId);
}